module.exports = __webpack_public_path__ + "img/icon-bike.cb07afd5.svg";